import React, { useState } from 'react';
import {
  useDepositData,
  useDepositProductsModal
} from './deposits/useDepositData';
import DepositAddForm from './deposits/DepositAddForm';
import DepositTable from './deposits/DepositTable';
import ProductsModal from './deposits/ProductsModal';
import AssignDepositProductModal from './deposits/AssignDepositProductModal';

const DepositManager = () => {
  const {
    deposits, loading, error, success,
    setError, setSuccess,
    loadDeposits,
    handleAddDeposit,
    handleSaveEdit,
    handleDeleteDeposit,
    handleAssignDepositProductForDeposit
  } = useDepositData();

  const [showAddForm, setShowAddForm] = useState(false);
  const [editingDeposit, setEditingDeposit] = useState(null);

  // Assign deposit product modal state
  const [showAssignDepositProductModal, setShowAssignDepositProductModal] = useState(false);
  const [depositToAssign, setDepositToAssign] = useState(null);

  const {
    selectedDeposit, depositProducts, showProductModal,
    productSearch, setProductSearch,
    searchResults, searchLoading,
    openModal: openProductModal,
    closeModal: closeProductModal,
    assignProduct, removeProduct
  } = useDepositProductsModal();

  if (loading) {
    return <div style={{ padding: '20px', textAlign: 'center' }}>Ladowanie kaucji...</div>;
  }

  const showSuccessMsg = (msg) => {
    setSuccess(msg);
    setTimeout(() => setSuccess(''), 3000);
  };

  return (
    <div className="admin-table-wrap" style={{ padding: '20px' }}>
      <style>{`
        @media (max-width: 600px) {
          .admin-table-wrap table { display: block; overflow-x: auto; -webkit-overflow-scrolling: touch; }
          .admin-table-wrap table th, .admin-table-wrap table td { white-space: nowrap; }
          /* Ukryj kolumne Kategoria (zwykle 3 kolumna) na mobile */
          .admin-table-wrap table th:nth-child(3), .admin-table-wrap table td:nth-child(3) { display: none; }
        }
        @media (max-width: 600px) {
          .admin-table-wrap > div[style*="space-between"]:first-child { flex-direction: column !important; align-items: stretch !important; gap: 0.5rem; }
        }
      `}</style>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h3 style={{ margin: 0 }}>Zarzadzanie Kaucjami</h3>
        <button
          onClick={() => { setShowAddForm(!showAddForm); }}
          style={{ padding: '6px 12px', fontSize: '12px', border: '1px solid var(--success)', color: 'var(--success)', cursor: 'pointer' }}
        >
          + Dodaj kaucje
        </button>
      </div>

      {/* Messages */}
      {error && (
        <div style={{ padding: '10px', backgroundColor: 'var(--danger-light)', color: 'var(--danger)', borderRadius: '4px', marginBottom: '15px' }}>
          {error}
          <button onClick={() => setError('')} style={{ float: 'right', background: 'none',  cursor: 'pointer' }}>&#x2715;</button>
        </div>
      )}
      {success && (
        <div style={{ padding: '10px', backgroundColor: 'var(--success-light)', color: 'var(--success)', borderRadius: '4px', marginBottom: '15px' }}>
          {success}
        </div>
      )}

      {/* Add form */}
      {showAddForm && (
        <DepositAddForm
          onAdd={(newDeposit, selectedProduct, resetForm) => {
            handleAddDeposit(newDeposit, selectedProduct, () => {
              resetForm();
              setShowAddForm(false);
            });
          }}
          onCancel={() => setShowAddForm(false)}
        />
      )}

      {/* Deposits table */}
      <DepositTable
        deposits={deposits}
        editingDeposit={editingDeposit}
        setEditingDeposit={setEditingDeposit}
        onEdit={(deposit) => setEditingDeposit({ ...deposit })}
        onSaveEdit={() => handleSaveEdit(editingDeposit, () => setEditingDeposit(null))}
        onDelete={handleDeleteDeposit}
        onManageProducts={async (deposit) => {
          await openProductModal(deposit);
        }}
        onAssignDepositProduct={(deposit) => {
          setDepositToAssign(deposit);
          setShowAssignDepositProductModal(true);
        }}
      />

      {/* Info box */}
      <div style={{ marginTop: '20px', padding: '15px', backgroundColor: 'var(--info-light)', borderRadius: '8px', border: '1px solid var(--info-light)' }}>
        <strong>Jak dzialaja kaucje:</strong>
        <ol style={{ margin: '10px 0 0 0', paddingLeft: '20px' }}>
          <li><strong>Utworz produkt "Kaucja"</strong> w systemie (np. w Produktach) z odpowiednia cena</li>
          <li><strong>Dodaj kaucje</strong> tutaj - wybierz produkt kaucji i nadaj nazwe</li>
          <li><strong>Przypisz produkty</strong> objete kaucja (np. napoje w butelkach zwrotnych)</li>
          <li>W POS gdy dodasz produkt z kaucja - kaucja automatycznie doda sie do koszyka</li>
        </ol>
      </div>

      {/* Products modal */}
      {showProductModal && selectedDeposit && (
        <ProductsModal
          selectedDeposit={selectedDeposit}
          depositProducts={depositProducts}
          productSearch={productSearch}
          setProductSearch={setProductSearch}
          searchResults={searchResults}
          searchLoading={searchLoading}
          onAssign={(productId) => assignProduct(productId,
            (msg) => { showSuccessMsg(msg); loadDeposits(); },
            (msg) => setError(msg)
          )}
          onRemove={(productId) => removeProduct(productId,
            (msg) => { showSuccessMsg(msg); loadDeposits(); },
            (msg) => setError(msg)
          )}
          onClose={closeProductModal}
        />
      )}

      {/* Assign deposit product modal */}
      {showAssignDepositProductModal && depositToAssign && (
        <AssignDepositProductModal
          depositToAssign={depositToAssign}
          onSelect={(product) => {
            handleAssignDepositProductForDeposit(depositToAssign, product, () => {
              setShowAssignDepositProductModal(false);
              setDepositToAssign(null);
            });
          }}
          onClose={() => {
            setShowAssignDepositProductModal(false);
            setDepositToAssign(null);
          }}
        />
      )}
    </div>
  );
};

export default DepositManager;
